import { T as store_get, _ as ensure_array_like, $ as attr, Y as escape_html, a0 as stringify, W as unsubscribe_stores, a1 as bind_props, S as pop, Q as push } from "../../../../chunks/index.js";
import "../../../../chunks/client.js";
import { p as page } from "../../../../chunks/stores.js";
import { t as truncate } from "../../../../chunks/util.js";
function _page($$payload, $$props) {
  push();
  var $$store_subs;
  let activeUrl;
  let data = $$props["data"];
  let pages = [];
  console.log(data);
  if (!data.delegations) data.delegations = [];
  activeUrl = store_get($$store_subs ??= {}, "$page", page).url.searchParams.get("page");
  {
    pages.forEach((page2) => {
      let splitUrl = page2.href.split("?");
      let queryString = splitUrl.slice(1).join("?");
      const hrefParams = new URLSearchParams(queryString);
      let hrefValue = hrefParams.get("page");
      if (hrefValue === activeUrl) {
        page2.active = true;
      } else {
        page2.active = false;
      }
    });
    pages = pages;
  }
  const each_array = ensure_array_like(data.delegations);
  $$payload.out += `<section class="container mx-auto text-sm"><h2 class="text-xl font-bold text-center text-gray-500 mb-4">Delegations</h2> <div class="flex flex-wrap justify-between mt-4 mb-2"><a href="#" class="px-4 py-2 text-blue-500 font-medium rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" role="button">&lt; Previous</a> <a href="#" class="px-4 py-2 text-blue-500 font-medium rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" role="button">Next ></a></div> <div class="overflow-x-auto"><table class="w-full bg-white border border-gray-300"><thead><tr><th class="py-2 px-4 bg-gray-100 font-bold text-center">Address</th><th class="py-2 px-4 bg-gray-100 font-bold text-center">Pool Id</th><th class="py-2 px-4 bg-gray-100 font-bold text-center">Block</th><th class="py-2 px-4 bg-gray-100 font-bold text-center">Transaction Hash</th></tr></thead><tbody><!--[-->`;
  for (let index = 0, $$length = each_array.length; index < $$length; index++) {
    let delegation = each_array[index];
    $$payload.out += `<tr${attr("class", index % 2 === 0 ? "bg-gray-50" : "bg-white")}><td class="py-2 px-4">${escape_html(delegation.address)}</td><td class="py-2 px-4">${escape_html(delegation.pool_id)}</td><td class="py-2 px-4 text-center"><a${attr("href", `/blocks/${stringify(delegation.block_number)}`)} class="text-blue-500">${escape_html(delegation.block_number)}</a></td><td class="py-2 px-4"><a${attr("href", `/transactions/${stringify(delegation.tx_hash)}`)} class="text-blue-500"><span class="ml-2">${escape_html(truncate(delegation.tx_hash, 30, "..."))}</span></a></td></tr>`;
  }
  $$payload.out += `<!--]--></tbody></table></div> <div class="flex flex-wrap justify-between mt-2 mb-2"><a href="#" class="px-4 py-2 text-blue-500 font-medium rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" role="button">&lt; Previous</a> <a href="#" class="px-4 py-2 text-blue-500 font-medium rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" role="button">Next ></a></div></section>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { data });
  pop();
}
export {
  _page as default
};
